import './index.scss'

import React from 'react'
import T from 'prop-types'
import { sortBy, get } from 'lodash'
import BEMHelper from 'react-bem-helper'
import { differenceInHours } from 'date-fns'
import { distance } from 'lib/date'
import Button from 'components/Button'

const bem = new BEMHelper('locations')

export default function Locations({ data, onSelect }) {
  const locations = sortBy(data, [
    (location) => location.first_available || new Date('2100-01-01'),
  ])

  const getSelectHandler = id => () => onSelect(id)

  return (
    <ul {...bem('')}>
      {locations.map(({ id, title, location, first_available }) => {
        const address = get(location, 'address', []).join(', ')
        const diff = first_available ? differenceInHours(first_available, new Date()) : null

        return (
          <li {...bem('item')} key={id}>
            <h2 {...bem('name')}>{title || 'Teststed uten navn'}</h2>

            {address ? <span {...bem('address')}>{address}</span> : null}

            <div {...bem('footer')}>
              {diff !== null && (
                <Button
                  arrow
                  noMargin
                  {...bem('button')}
                  onClick={getSelectHandler(id)}
                >
                  Vis ledige tider
                </Button>
              )}

              <span {...bem('time')}>
                <span
                  {...bem('indicator', {
                    warning: diff === null || diff > 30,
                    info: diff > 12,
                    success: diff <= 12,
                  })}
                />
                {diff === null ? 'Ingen ledige timer' : null}
                {diff < 0 ? 'Ledig nå' : null}
                {diff > 0
                  ? `Første ledige ${distance(first_available, new Date())}`
                  : null}
              </span>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

Locations.propTypes = {
  data: T.array.isRequired,
  onSelect: T.func.isRequired,
}
